// extracted by mini-css-extract-plugin
export default {"btn":"CornerBtn_btn__6Z9Dq","btn__text":"CornerBtn_btn__text__IrseT"};